import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/insurance/Data Table";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Modal } from "react-bootstrap";

import {
  faEye,
  faPenToSquare,
  faTrash,
  faEnvelope,
  faCopy,
  faHistory,
} from "@fortawesome/free-solid-svg-icons";
import Add_data_modal from "../../components/insurance/update_data_modal";
import Layouts from "../../layouts/layouts";
import InsuranceDetailModal from "../../components/insurance/Insurance Details";
import * as XLSX from "xlsx"; // Import XLSX library for Excel export
import Switch from "react-switch";

export default function Insurance() {
  const navigate = useNavigate();
  const title = "Document Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showInsuranceDetailModal, setShowInsuranceDetailModal] =
    useState(false);
  const [selectedInsurance, setSelectedInsurance] = useState(null);
  const [isFiltered, setIsFiltered] = useState(false); // Track if filters are applied
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [showDocModal, setShowDocModal] = useState(false);
  const [selectedDocuments, setSelectedDocuments] = useState([]);
  const [selectedRowForDocs, setSelectedRowForDocs] = useState(null);
  const [showOtpOverlay, setShowOtpOverlay] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpLoading, setOtpLoading] = useState(false);
  const [otpError, setOtpError] = useState("");
  const [pendingFile, setPendingFile] = useState(null);
  const [pendingRow, setPendingRow] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const formatDate = (dateString) => {
    if (!dateString || isNaN(Date.parse(dateString))) return "-"; // or return "" if you prefer blank
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };
  const handleDocumentOpen = async (row, file) => {
    if (!file?.public_id && !file?.url) {
      alert("Invalid document file.");
      return;
    }

    const activeRow = row || selectedRowForDocs || {};
    // const secure = !!(activeRow?.clientId || activeRow?.leaseId);
    const secure = !activeRow?.vehicleId;
    const token = localStorage.getItem("token");

    // ✅ DIRECT DOWNLOAD (NO OTP)
    if (!secure) {
      window.location.href = file.url;
      return;
    }

    // ✅ ✅ ✅ OPEN OTP WINDOW INSTANTLY
    setShowDocModal(false); // ✅ ✅ ✅ VERY IMPORTANT
    setSelectedDocuments([]); // ✅ cleanup

    setPendingFile(file);
    setPendingRow(activeRow);
    setOtp("");
    setOtpError("");
    setShowOtpOverlay(true); // ✅ OTP WILL NOW ACCEPT INPUT

    try {
      // ✅ REQUEST OTP IN BACKGROUND (NO UI DELAY)
      await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/insurance/otp/request`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
    } catch (error) {
      console.error("OTP Request Error:", error);
      setOtpError("Failed to send OTP. Try again.");
    }
  };

  // const handleDocumentOpen = async (row, file) => {
  //   // ✅ SAFETY: Validate file
  //   if (!file?.public_id && !file?.url) {
  //     alert("Invalid document file.");
  //     return;
  //   }

  //   // ✅ SAFETY: Row may be null from modal — fallback
  //   const activeRow = row || selectedRowForDocs || {};

  //   // ✅ SECURITY RULE:
  //   // If either clientId OR leaseId exists → OTP REQUIRED
  //   const secure = !!(activeRow?.clientId || activeRow?.leaseId);

  //   const token = localStorage.getItem("token");

  //   // ✅ DIRECT DOWNLOAD (NO OTP)
  //   if (!secure) {
  //     window.location.href = file.url;
  //     return;
  //   }

  //   try {
  //     // ✅ 1. REQUEST OTP
  //     await axios.post(
  //       `${process.env.REACT_APP_BASE_URL}/api/insurance/otp/request`,
  //       {},
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     // ✅ 2. ENTER OTP
  //     const otp = window.prompt("Enter OTP sent to your email:");
  //     if (!otp) return;

  //     // ✅ 3. VERIFY OTP & GET SIGNED URL
  //     const { data } = await axios.post(
  //       `${process.env.REACT_APP_BASE_URL}/api/insurance/otp/verify`,
  //       {
  //         otp,
  //         fileKey: file.public_id,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );

  //     // ✅ 4. FORCE OPEN / DOWNLOAD
  //     if (data?.signedUrl) {
  //       window.location.href = data.signedUrl;
  //     } else {
  //       alert("Signed URL not received.");
  //     }
  //   } catch (error) {
  //     console.error("OTP Error:", error);
  //     alert(
  //       error.response?.data?.message ||
  //         "OTP verification failed. Please try again."
  //     );
  //   }
  // };
  const handleVerifyOtp = async () => {
    if (otp.length !== 6) {
      setOtpError("Enter valid 6 digit OTP");
      return;
    }

    const token = localStorage.getItem("token");
    setOtpLoading(true);
    setOtpError("");

    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/insurance/otp/verify`,
        {
          otp,
          fileKey: pendingFile.public_id,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      if (data?.signedUrl) {
        setShowOtpOverlay(false); // ✅ CLOSE OTP SCREEN
        window.location.href = data.signedUrl; // ✅ DOWNLOAD
      } else {
        setOtpError("Download failed. Try again.");
      }
    } catch (error) {
      setOtpError(error.response?.data?.message || "OTP verification failed");
    } finally {
      setOtpLoading(false);
    }
  };

  const openDocumentsModal = (row) => {
    setSelectedDocuments(row.documentCopy);
    setSelectedRowForDocs(row); // ✅ STORE FULL ROW
    setShowDocModal(true);
  };

  const closeDocumentsModal = () => {
    setShowDocModal(false);
    setSelectedDocuments([]);
  };

  const columns = [
    {
      name: <b>Vehicle Number </b>,
      selector: (row) => (row.vehicleId ? row.vehicleId.numberplate : "-"),
      sortable: true,
    },
    {
      name: <b>Leasing Partner </b>,
      selector: (row) => (row.leaseId ? row.leaseId.leasing_partner : "-"),
      sortable: true,
    },
    {
      name: <b>Client </b>,
      selector: (row) => (row.clientId ? row.clientId.name : "-"),
      sortable: true,
    },
    {
      name: <b>Document Type </b>,
      selector: (row) => (row.documenttypeId ? row.documenttypeId?.name : "-"),
      sortable: true,
    },
    {
      name: <b>Document</b>,
      cell: (row) => {
        const totalDocs = row.documentCopy?.length || 0;

        // ✅ NO DOCUMENT
        if (totalDocs === 0) return "-";

        // ✅ SINGLE DOCUMENT → DIRECT DOWNLOAD
        if (totalDocs === 1) {
          return (
            <button
              className="btn btn-sm btn-primary"
              onClick={
                () => handleDocumentOpen(row, row.documentCopy[0]) // ✅ FIXED
              }
            >
              Download
            </button>
          );
        }

        // ✅ MULTIPLE DOCUMENTS → OPEN MODAL
        return (
          <button
            className="btn btn-sm btn-outline-primary"
            onClick={() => openDocumentsModal(row)} // ✅ CORRECT
          >
            View ({totalDocs})
          </button>
        );
      },
      sortable: false,
    },

    // {
    //   name: <b>Document</b>,
    //   cell: (row) =>
    //     row.documentCopy?.length > 0 ? (
    //       <div className="d-flex flex-wrap gap-2">
    //         {row.documentCopy.map((file, index) => (
    //           <button
    //             key={index}
    //             onClick={() => handleDocumentOpen(row, file)}
    //             style={{
    //               padding: "5px 12px",
    //               backgroundColor: "#1976d2",
    //               color: "#fff",
    //               border: "none",
    //               borderRadius: "4px",
    //               cursor: "pointer",
    //             }}
    //           >
    //             Download
    //           </button>
    //         ))}
    //       </div>
    //     ) : (
    //       "-"
    //     ),
    //   sortable: false,
    // },
    {
      name: <b>Due Date</b>,
      selector: (row) => formatDate(row.Date),
      cell: (row) => {
        if (!row.Date) {
          return <span className="text-gray-400">-</span>;
        }

        const formatted = formatDate(row.Date);
        return (
          <div
            style={{
              backgroundColor: "#F3F4F6", // subtle gray bg
              borderRadius: "6px",
              padding: "6px 10px",
              fontWeight: 600,
              fontSize: "0.85rem",
              textAlign: "center",
              color: "#111827",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
          >
            {formatted}
          </div>
        );
      },
      sortable: true,
      center: true,
    },

    {
      name: <b>Status / Days Left</b>,
      cell: (row) => {
        if (!row.Date) return <span className="text-gray-500">-</span>;

        const dueDate = new Date(row.Date);
        const today = new Date();
        const diffDays = Math.ceil((dueDate - today) / (1000 * 60 * 60 * 24));

        const isExpired = diffDays < 0;
        const isExpiringSoon = diffDays <= 30 && diffDays >= 0;

        const bgColor = isExpired
          ? "#FEE2E2" // light red
          : isExpiringSoon
            ? "#FEF3C7" // light yellow
            : "#DCFCE7"; // light green

        const textColor = isExpired
          ? "#B91C1C"
          : isExpiringSoon
            ? "#92400E"
            : "#166534";

        const label = isExpired
          ? "Expired"
          : diffDays === 0
            ? "Today"
            : `${diffDays} days left`;

        return (
          <div
            style={{
              backgroundColor: bgColor,
              color: textColor,
              borderRadius: "6px",
              padding: "4px 10px",
              fontWeight: 600,
              fontSize: "0.8rem",
              textAlign: "center",
              minWidth: "100px",
              boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
            }}
          >
            {label}
          </div>
        );
      },
      sortable: true,
      center: true,
    },

    {
      name: <b>Paid Amount </b>,
      selector: (row) => row.amountPaid || "-",
      sortable: true,
    },
    {
      name: <b>State </b>,
      selector: (row) => row.state || "-",
      sortable: true,
    },
    {
      name: <b>Done Date</b>,
      selector: (row) => (row.DoneDate ? formatDate(row.DoneDate) : "-"),
      sortable: true,
    },

    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          {row.status === "created" && (
            <>
              <button
                onClick={() => copyLink()}
                className=" btn btn-success btn-sm"
              >
                <FontAwesomeIcon icon={faCopy} />
              </button>
              <button className=" btn btn-primary btn-sm ms-1">
                <FontAwesomeIcon icon={faEnvelope} />
              </button>
            </>
          )}
          <button
            onClick={() => setUpdateStoreBtn(row)}
            className=" btn btn-info btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faPenToSquare} />
          </button>
          {/* <button
            onClick={() => delete_row(row)}
            className=" btn btn-danger btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button> */}
          <button
            onClick={() => viewInsurance(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
          {/* <button
            onClick={() => handleInsuranceHistoryClick(row)}
            className="btn btn-warning btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faHistory} />
          </button> */}
          <button
            onClick={() => handleInsuranceHistoryClick(row)}
            className="btn btn-warning btn-sm ms-1"
            disabled={!row?.vehicleId?._id} // ✅ DISABLE SAFELY
            title={
              row?.vehicleId?._id
                ? "View Insurance History"
                : "Vehicle not assigned"
            }
          >
            <FontAwesomeIcon icon={faHistory} />
          </button>

          <button
            onClick={() => delete_row(row)}
            className=" btn btn-danger btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faTrash} />
          </button>
        </>
      ),
    },
  ];
  const handleInsuranceHistoryClick = (row) => {
    navigate(`/insurancehistory/${row.vehicleId._id}`);
  };
  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const delete_row = (row) => {
    Swal.fire({
      icon: "warning",
      title: "You wont be able to revert this!",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        const token = localStorage.getItem("token");
        if (!token) {
          console.error("No token found");
          return;
        }
        axios
          .delete(
            `${process.env.REACT_APP_BASE_URL}/api/insurance/${row._id}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              },
            },
          )
          .then(() => {
            Swal.fire("Deleted!", "Insurance has been deleted.", "success");
            fetchInsurance(currentPage);
          })
          .catch((error) => {
            Swal.fire("Error!", "Insurance could not be deleted.", "error");
            console.error("Error deleting documents:", error);
          });
      }
    });
  };

  const fetchInsurance = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/insurance`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      if (Array.isArray(response.data.insurance)) {
        setApiState(response.data.insurance);
      } else {
        console.error("Unexpected data format from API", response.data);
      }
      setApiCol(columns);
    } catch (error) {
      console.log("Error fetching insurance:", error);
    }
  };

  useEffect(() => {
    fetchInsurance(currentPage);
  }, [currentPage]);
  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const copyLink = () => {
    alert(46);
  };

  const updateInsurance = (updatedInsurance) => {
    setApiState((prev) =>
      prev.map((insurance) =>
        insurance._id === updateInsurance._id ? updateInsurance : insurance,
      ),
    );
  };

  const handleUpdateInsurance = (updatedInsuranceData) => {
    const token = localStorage.getItem("token");
    if (!token) {
      console.error("No token found");
      return;
    }

    axios
      .put(
        `${process.env.REACT_APP_BASE_URL}/api/insurance/${updatedInsuranceData._id}`,
        updatedInsuranceData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      )
      .then((response) => {
        Swal.fire(
          "Updated!",
          "Insurance details have been updated.",
          "success",
        );
        updateInsurance(response.data.insrance);
      })
      .catch((error) => {
        Swal.fire("Error!", "Insurance details could not be updated.", "error");
        console.error(
          "Error updating insurance:",
          error.response ? error.response.data : error.message,
        );
      });
  };

  const viewInsurance = (insurance) => {
    setSelectedInsurance(insurance);
    setShowInsuranceDetailModal(true);
  };

  const exportToExcel = () => {
    const transformedData = apistate.map((insurance) => ({
      "Vehicle Number": insurance.vehicleId
        ? insurance.vehicleId.numberplate
        : "-",
      "Leasing Partner": insurance.leaseId
        ? insurance.leaseId.leasing_partner
        : "-",
      "Client Name": insurance.clientId ? insurance.clientId.name : "-",
      "Document Type": insurance.documenttypeId
        ? insurance.documenttypeId.name
        : "-",
      Insurance_Date: insurance.Date ? insurance.Date : "Date",
      Amount: insurance.amountPaid ? insurance.amountPaid : "Amount",
      Insurance_Done_Date: insurance.DoneDate ? insurance.DoneDate : "Date",
      State: insurance.state ? insurance.state : "State",
      POC_Name: insurance.pocName ? insurance.pocName : "POC_Name",
      POC_Contact: insurance.pocContact ? insurance.pocContact : "POC_Contact",
      Comments: insurance.comments ? insurance.comments : "Comments",
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Insurance");

    XLSX.writeFile(workbook, "insurance.xlsx");
  };

  const sendPendingDocumentsEmail = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      Swal.fire("Unauthorized!", "Please login again.", "warning");
      return;
    }

    try {
      Swal.fire({
        title: "Checking Documents...",
        text: "Checking pending documents for active vehicles, clients and leasing partners.",
        allowOutsideClick: false,
        allowEscapeKey: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/insurance/send-pending-documents-email`,
        {},
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const result = response.data;

      Swal.fire({
        icon: "success",
        title: "Email Sent Successfully",
        html: `
        <div style="text-align: left;">
          <p>
            <strong>Vehicle Pending Documents:</strong>
            ${result.summary?.vehicles || 0}
          </p>

          <p>
            <strong>Client Pending Documents:</strong>
            ${result.summary?.clients || 0}
          </p>

          <p>
            <strong>Leasing Partner Pending Documents:</strong>
            ${result.summary?.leases || 0}
          </p>

          <hr />

          <p class="mb-0">
            <strong>Total Pending Documents:</strong>
            ${result.summary?.total || 0}
          </p>
        </div>
      `,
        confirmButtonText: "OK",
      });
    } catch (error) {
      console.error(
        "Pending documents email error:",
        error.response?.data || error,
      );

      Swal.fire(
        "Error!",
        error.response?.data?.message ||
          "Failed to send pending documents email.",
        "error",
      );
    }
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <Add_data_modal
        select_data={update_modal_data}
        open_update_data_modal={open_update_modal}
        onUpdateInsurance={updateInsurance}
      />
      <InsuranceDetailModal
        show={showInsuranceDetailModal}
        onHide={() => setShowInsuranceDetailModal(false)}
        insurance={selectedInsurance}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <button
                    type="button"
                    onClick={sendPendingDocumentsEmail}
                    className="btn btn-warning btn-sm me-2"
                  >
                    <FontAwesomeIcon icon={faEnvelope} className="me-1" />
                    Send Pending Documents
                  </button>
                  <Link to="/create_insurance">
                    <div className="btn btn-info btn-sm text-white me-2">
                      Add Documents
                    </div>
                  </Link>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm text-white"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="vehiclenumber"
                    title_btn={true}
                    apidata={apistate}
                    // columns={apicol}
                    columns={columns}
                  />
                ) : (
                  <p>Loading...</p>
                )}
                <Modal
                  show={showDocModal}
                  onHide={closeDocumentsModal}
                  centered
                >
                  <Modal.Header closeButton>
                    <Modal.Title>Documents</Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    {selectedDocuments.length === 0 ? (
                      <p className="text-muted">No documents available.</p>
                    ) : (
                      <div className="list-group">
                        {selectedDocuments.map((file, index) => (
                          <div
                            key={index}
                            className="list-group-item d-flex justify-content-between align-items-center"
                          >
                            {/* ✅ FILE NAME */}
                            <span className="text-truncate me-3">
                              {decodeURIComponent(
                                file.url
                                  .split("/")
                                  .pop()
                                  .split("-")
                                  .slice(1)
                                  .join("-"),
                              )}
                            </span>

                            {/* ✅ DOWNLOAD BUTTON */}
                            <button
                              className="btn btn-sm btn-success flex-shrink-0"
                              onClick={() =>
                                handleDocumentOpen(selectedRowForDocs, file)
                              }
                            >
                              Download
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </Modal.Body>

                  <Modal.Footer>
                    <button
                      className="btn btn-secondary"
                      onClick={closeDocumentsModal}
                    >
                      Close
                    </button>
                  </Modal.Footer>
                </Modal>
                {/* ✅ ✅ ✅ BLUR BACKGROUND OTP OVERLAY */}
                {showOtpOverlay && (
                  <div
                    style={{
                      position: "fixed",
                      inset: 0,
                      zIndex: 9999,
                      backdropFilter: "blur(8px)",
                      WebkitBackdropFilter: "blur(8px)",
                      background: "rgba(0, 0, 0, 0.35)",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",

                      pointerEvents: "auto", // ✅ ALLOW INTERACTION
                    }}
                  >
                    <div
                      style={{
                        background: "#ffffff",
                        padding: "40px",
                        borderRadius: "18px",
                        width: "360px",
                        textAlign: "center",
                        boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
                        animation: "scaleIn 0.25s ease",
                      }}
                    >
                      <h4 className="mb-2 fw-bold text-primary">Enter OTP</h4>

                      <p className="text-muted mb-3">
                        A 6-digit OTP has been sent to your registered email
                      </p>

                      {/* ✅ OTP INPUT */}
                      <input
                        type="text"
                        value={otp}
                        maxLength={6}
                        autoFocus
                        inputMode="numeric"
                        onChange={(e) =>
                          setOtp(e.target.value.replace(/[^0-9]/g, ""))
                        }
                        className="form-control text-center fw-bold mb-3"
                        style={{
                          fontSize: "22px",
                          letterSpacing: "8px",
                          padding: "12px",
                          pointerEvents: "auto", // ✅ FIX CLICK BLOCKING
                        }}
                        placeholder="_ _ _ _ _ _"
                      />

                      {/* ✅ ERROR MESSAGE */}
                      {otpError && (
                        <div className="text-danger mb-2 fw-semibold">
                          {otpError}
                        </div>
                      )}

                      {/* ✅ BUTTONS */}
                      <div className="d-flex gap-2 mt-3">
                        <button
                          className="btn btn-outline-secondary w-50"
                          disabled={otpLoading}
                          onClick={() => setShowOtpOverlay(false)}
                        >
                          Cancel
                        </button>

                        <button
                          className="btn btn-primary w-50"
                          disabled={otpLoading}
                          onClick={handleVerifyOtp}
                        >
                          {otpLoading ? "Verifying..." : "Verify"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
